import { FORMAT, formatDateTime } from '../../../../helpers/datetime'
import { formatText } from '../../../../helpers/value'

export const SCHEMA = {
  SENTIMENT: {
    label: 'industryOverview.recentNews.SENTIMENT',
    key: 'newsTypeName',
    format: (val) => formatText(val),
  },
  HEADLINE: {
    label: 'industryOverview.recentNews.HEADLINE',
    key: 'title',
    format: (val) => formatText(val),
  },
  EVENT: {
    label: 'industryOverview.recentNews.EVENT',
    key: 'newsCategoryName',
    format: (val) => formatText(val),
  },
  PUBLICATION_DATE: {
    label: 'industryOverview.recentNews.PUBLICATION_DATE',
    key: 'publicDate',
    format: (val, locale) => formatDateTime(val, FORMAT.DATE, locale),
  },
}

export const INDUSTRY_NEWS_TYPE_ID = 7
